import React, { useState } from "react";
import { motion } from "framer-motion";
import { routeVariantsRight } from "../../assets/animates/routeVariants";
import { useTranslation } from "react-i18next";

const AboutUsTabs = () => {
  const { t } = useTranslation();

  const [currentTab, setCurrentTab] = useState("11");

  const handleTabClick = (e) => {
    setCurrentTab(e.target.id);
  };

  return (
    <div className="row mx-md-auto pb-50 mt-100">
      {/* <h2 className='text-center font-weight-bold mb-50'>{t('about-us-page.about-us-page-content.content-3.heading')}</h2> */}
      <div className="about-us-tabs">
        {/* {tabs.map((tab, i) =>
                    <button key={i} id={tab.id} disabled={currentTab === `${tab.id}`} onClick={(handleTabClick)}>{tab.tabTitle}</button>
                )} */}
        <button
          key="1"
          id="1"
          disabled={currentTab === "1"}
          onClick={handleTabClick}
        >
          2016
        </button>
        <button
          key="2"
          id="2"
          disabled={currentTab === "2"}
          onClick={handleTabClick}
        >
          2017
        </button>
        <button
          key="3"
          id="3"
          disabled={currentTab === "3"}
          onClick={handleTabClick}
        >
          2018
        </button>
        <button
          key="4"
          id="4"
          disabled={currentTab === "4"}
          onClick={handleTabClick}
        >
          2019
        </button>
        <button
          key="5"
          id="5"
          disabled={currentTab === "5"}
          onClick={handleTabClick}
        >
          2020
        </button>
        <button
          key="6"
          id="6"
          disabled={currentTab === "6"}
          onClick={handleTabClick}
        >
          2021
        </button>
        <button
          key="7"
          id="7"
          disabled={currentTab === "7"}
          onClick={handleTabClick}
        >
          2022
        </button>
        <button
          key="8"
          id="8"
          disabled={currentTab === "8"}
          onClick={handleTabClick}
        >
          2023
        </button>
        <button
          key="9"
          id="9"
          disabled={currentTab === "9"}
          onClick={handleTabClick}
        >
          2024
        </button>
        <button
          key="10"
          id="10"
          disabled={currentTab === "10"}
          onClick={handleTabClick}
        >
          2025
        </button>
        <button
          key="11"
          id="11"
          disabled={currentTab === "11"}
          onClick={handleTabClick}
        >
          2026
        </button>
      </div>
      <div className="about-us-content">
        {/* {tabs.map((tab, i) =>
                    <div key={i}>
                        {currentTab === `${tab.id}` && 
                        <div>
                            <p className='font-14'><b>{tab.title}</b>{tab.content}</p>
                            
                        </div>}
                    </div>
                )} */}
        <div key="1">
          {currentTab === "1" && (
            <motion.div
              variants={routeVariantsRight}
              initial="initial"
              animate="final"
              className="mt-20"
            >
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.oct")}
              </h2>
              <ul>
                <li>
                  <p>{t("aboutus.2016-oct-1")}{" "} <a href="https://repository.mobile-id.vn/" target="_blank" rel="noreferrer" >https://repository.mobile-id.vn/</a></p>
                </li>
                <li>
                  <p>{t("aboutus.2016-oct-2")}</p>
                </li>
                <li className="no-bullet">
                  <p>{t("aboutus.2016-oct-2-1")}</p>
                </li>
                <li className="no-bullet">
                  <p>{t("aboutus.2016-oct-2-2")}</p>
                </li>
                <li className="no-bullet">
                  <p>{t("aboutus.2016-oct-2-3")}</p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.sept")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2016-sept",
                    )}
                  </p>
                </li>
              </ul>
            </motion.div>
          )}
        </div>
        <div key="2">
          {currentTab === "2" && (
            <motion.div
              variants={routeVariantsRight}
              initial="initial"
              animate="final"
              className="mt-20"
            >
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.nov")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2017-nov",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.apr")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2017-apr",
                    )}
                  </p>
                </li>
              </ul>
            </motion.div>
          )}
        </div>
        <div key="3">
          {currentTab === "3" && (
            <motion.div
              variants={routeVariantsRight}
              initial="initial"
              animate="final"
              className="mt-20"
            >
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.jul")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2018-jul",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.mar")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2018-mar",
                    )}
                  </p>
                </li>
              </ul>

              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.jan")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2018-jan",
                    )}
                  </p>
                </li>
              </ul>
            </motion.div>
          )}
        </div>
        <div key="4">
          {currentTab === "4" && (
            <motion.div
              variants={routeVariantsRight}
              initial="initial"
              animate="final"
              className="mt-20"
            >
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.dec")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2019-dec",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.nov")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2019-nov",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.oct")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2019-oct",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.jul")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2019-jul",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.may")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2019-may",
                    )}
                  </p>
                </li>
              </ul>
            </motion.div>
          )}
        </div>
        <div key="5">
          {currentTab === "5" && (
            <motion.div
              variants={routeVariantsRight}
              initial="initial"
              animate="final"
              className="mt-20"
            >
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.dec")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2020-dec",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.nov")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2020-nov",
                    )}
                  </p>
                </li>
              </ul>

              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.jul")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2020-jul-1",
                    )}
                  </p>
                </li>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2020-jul-2",
                    )}
                  </p>
                </li>
              </ul>

              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.may")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2020-may",
                    )}
                  </p>
                </li>
              </ul>

              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.apr")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2020-apr-1",
                    )}
                  </p>
                </li>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2020-apr-2",
                    )}
                  </p>
                </li>
              </ul>
            </motion.div>
          )}
        </div>
        <div key="6">
          {currentTab === "6" && (
            <motion.div
              variants={routeVariantsRight}
              initial="initial"
              animate="final"
              className="mt-20"
            >
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.sept")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2021-sept",
                    )}
                    <a
                      href="https://csrc.nist.gov/projects/cryptographic-module-validation-program/certificate/4035"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://csrc.nist.gov/projects/cryptographic-module-validation-program/certificate/4035
                    </a>
                    .
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.apr")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2021-apr",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.mar")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2021-mar-1",
                    )}
                  </p>
                </li>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2021-mar-2",
                    )}
                  </p>
                </li>
              </ul>
            </motion.div>
          )}
        </div>
        <div key="7">
          {currentTab === "7" && (
            <motion.div
              variants={routeVariantsRight}
              initial="initial"
              animate="final"
              className="mt-20"
            >
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.dec")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2022-dec",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.jul")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2022-jul",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.mar")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2022-mar-1",
                    )}
                  </p>
                </li>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2022-mar-2",
                    )}
                  </p>
                </li>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2022-mar-3",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.jan")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2022-jan-1",
                    )}
                  </p>
                </li>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2022-jan-2",
                    )}
                  </p>
                </li>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2022-jan-3",
                    )}
                  </p>
                </li>
              </ul>
            </motion.div>
          )}
        </div>
        <div key="8">
          {currentTab === "8" && (
            <motion.div
              variants={routeVariantsRight}
              initial="initial"
              animate="final"
              className="mt-20"
            >
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.oct")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2023-oct",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.sept")}
              </h2>
              <ul>
                <li>
                  <p>{t("aboutus.2023-sep-1")}</p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.jun")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2023-jun",
                    )}
                  </p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.mar")}
              </h2>
              <ul>
                <li>
                  <p>
                    {t(
                      "about-us-page.about-us-page-content.content-3.tabs.2023-mar",
                    )}
                  </p>
                </li>
              </ul>
            </motion.div>
          )}
        </div>
        <div key="9">
          {currentTab === "9" && (
            <motion.div
              variants={routeVariantsRight}
              initial="initial"
              animate="final"
              className="mt-20"
            >
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.dec")}
              </h2>
              <ul>
                <li>
                  <p>{t("aboutus.2024-dec-1")}</p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.mar")}
              </h2>
              <ul>
                <li>
                  <p>{t("aboutus.2024-mar-1")}</p>
                </li>
                <li>
                  <p>{t("aboutus.2024-mar-2")}</p>
                </li>
                <li>
                  <p>{t("aboutus.2024-mar-3")}</p>
                </li>
              </ul>
            </motion.div>
          )}
        </div>
        <div key="10">
          {currentTab === "10" && (
            <motion.div
              variants={routeVariantsRight}
              initial="initial"
              animate="final"
              className="mt-20"
            >
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.oct")}
              </h2>
              <ul>
                <li>
                  <p>{t("aboutus.2025-oct-1")}</p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.aug")}
              </h2>
              <ul>
                <li>
                  <p>{t("aboutus.2025-aug-1")}</p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.may")}
              </h2>
              <ul>
                <li>
                  <p>{t("aboutus.2025-may-1")}</p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.apr")}
              </h2>
              <ul>
                <li>
                  <p>{t("aboutus.2025-apr-1")}</p>
                </li>
              </ul>
            </motion.div>
          )}
        </div>
        <div key="11">
          {currentTab === "11" && (
            <motion.div
              variants={routeVariantsRight}
              initial="initial"
              animate="final"
              className="mt-20"
            >
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.jul")}
              </h2>
               <ul>
                 <li>
                  <p>{t("aboutus.2026-jul-2")} {" "}<a href="https://www.gdt.gov.vn/wps/portal/!ut/p/z1/tVNLb4JAEP4r9eCR7KDAwtGiUbS0GMtrL2ZZKN3GRawb7M_vkqaHHgQa271MJvkek29nEEEJIhVteEklP1b0oPqUWHt3u3GjTQRgh8EcPN_HUejNAZ4xir8Ay9nKwA8KYCwBPOP-6XHlbnXwpogM4cOVN4M-foQIIqyStXxFaZnLO3asZFHJMZzpXvVt1Tg7j0EyxvJmDLZuWjgzqZZl8KIZtNA1R88c1TqGk00sk9K8Fb0wwWUheI7SoZSaDUbHfcGS7lji1u-HQrBQeftbbFlYn9ie-Q3o-Jo-k1QNia8OuTZQ3PDigsLq-C7Usux-mcGq18G60aFTfrmB_5Wf3Ci_7lt-dZ387XQiM3UC7dp_SJT83Q3UIgyFPRVaAjwQbmb7i6lZin1bDuVo9AkmTOe7/dz/d5/L2dBISEvZ0FBIS9nQSEh/" target="_blank" rel="noreferrer" >{t("aboutus.detail_here")}</a></p>
                </li>
                <li>
                  <p>{t("aboutus.2026-jul-1")}</p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.jun")}
              </h2>
               <ul>
                 <li>
                  <p>{t("aboutus.2026-jun-2")}</p>
                </li>
                <li>
                  <p>{t("aboutus.2026-jun-1")}{" "} <a href="https://csrc.nist.gov/projects/cryptographic-module-validation-program/certificate/5331" target="_blank" rel="noreferrer">https://csrc.nist.gov/projects/cryptographic-module-validation-program/certificate/5331</a></p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.feb")}
              </h2>
              <ul>
                 <li>
                  <p>{t("aboutus.2026-feb-3")}</p>
                </li>
                 <li>
                  <p>{t("aboutus.2026-feb-2")}</p>
                </li>
                <li>
                  <p>{t("aboutus.2026-feb-1")}</p>
                </li>
              </ul>
              <h2 className="font-weight-bold">
                {t("about-us-page.about-us-page-content.content-3.tabs.jan")}
              </h2>
              <ul>
                <li>
                  <p>{t("aboutus.2026-jan-1")}</p>
                </li>
                <li>
                  <p>{t("aboutus.2026-jan-2")}</p>
                </li>
              </ul>
            </motion.div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutUsTabs;
